import { handleActions, createAction } from "redux-actions";
import { api } from "../../../services";
import { UserSearchFormat, AdStatus } from "../../../models";

const REPORT_GET = "REPORT_GET";
const REPORT_UPDATE = "REPORT_UPDATE";
const AD_TOOGLE_BLOCK = "AD_TOOGLE_BLOCK";

export const getReports = createAction(
  REPORT_GET,
  async (filters, page, itemPerPage) => {
    try {
      const result = await api.Report.list({ ...filters, page, itemPerPage });
      return {
        page,
        itemPerPage,
        reports: await fillReportersUserName(result.data),
        total: result.count
      };
    } catch (e) {
      return { reports: [] };
    }
  }
);

const fillReportersUserName = async reports => {
  if (reports.length === 0) {
    return reports;
  }

  let userIds: any = new Set();
  reports.map(report => userIds.add(report.reporterId));
  userIds = Array.from(userIds);
  const userNames = await api.User.list({
    ids: userIds,
    format: UserSearchFormat.username
  });

  return reports.map(report => ({
    ...report,
    reporter: userNames.data[userIds.indexOf(report.reporterId)]
  }));
};

export const updateReport = createAction(
  REPORT_UPDATE,
  async (id, data, reports, callback) => {
    try {
      await api.Report.update(id, data);

      const updatedReports = reports.map(report => {
        if (report.id === id) {
          return {
            ...report,
            ...data
          };
        }

        return report;
      });

      callback && callback();

      return { reports: updatedReports };
    } catch (e) {
      callback && callback();

      return null;
    }
  }
);

export const toggleBlockAd = createAction(
  AD_TOOGLE_BLOCK,
  async (adStatus, adId) => {
    try {
      if (adStatus === AdStatus.blocked) {
        await api.Ads.unblock(adId);
      } else {
        await api.Ads.block({ adId });
      }

      return { adId };
    } catch (e) {
      return null;
    }
  }
);

const defaultState = {
  page: 1,
  itemPerPage: 10,
  total: 0,
  reports: [],
  filters: {}
};

const updateState = (state, { payload }) => ({
  ...state,
  ...payload
});

const setAdStatus = (state, { payload }) => {
  if (!payload) {
    return state;
  }

  const reports = state.reports.map(r => {
    const report = r;

    if (report.adId === payload.adId) {
      report.adStatus =
        report.adStatus === AdStatus.blocked ? null : AdStatus.blocked;
    }

    return report;
  });

  return {
    ...state,
    reports
  };
};

export default handleActions(
  {
    [REPORT_GET]: updateState,
    [REPORT_UPDATE]: updateState,
    [AD_TOOGLE_BLOCK]: setAdStatus
  },
  defaultState
);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageReportPage/report.ducks.ts